import React, {FC} from 'react'

export enum TOP_FAN_LEADER_STATUSES {
    pending = 'pending',
    completed = 'completed'
}

type ProgressConfig = {
    progress: number
    size: number
    strokeWidth: number
    borderRadius: number
}

type SquareProgressProps = {
    status: TOP_FAN_LEADER_STATUSES
    progressConfig: ProgressConfig
    children?: React.ReactNode
}

export const SquareProgress: FC<SquareProgressProps> = ({status, progressConfig, children}) => {
    const {progress, size, strokeWidth, borderRadius} = progressConfig
    const PI = 3.14
    const sideLength = size
    const effectiveSideLength = sideLength - strokeWidth * 2
    const fullLength = effectiveSideLength * 4 - borderRadius * 8 + PI * borderRadius * 2
    const dashOffset = fullLength - (progress / 100) * fullLength
    const useGradient = status === TOP_FAN_LEADER_STATUSES.completed

    const strokeColor: string | string[] = {
        [TOP_FAN_LEADER_STATUSES.pending]: '#FFBF1B',
        [TOP_FAN_LEADER_STATUSES.completed]: ['#E5D2A5', '#FEB80C']
    }[status]

    return (
        <svg width={size} height={size}>
            {children && (
                <foreignObject x={strokeWidth} y={strokeWidth} width={effectiveSideLength} height={effectiveSideLength}>
                    <div
                        style={{
                            borderRadius: '5px',
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden'
                        }}
                    >
                        {children}
                    </div>
                </foreignObject>
            )}

            {useGradient && (
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor={(strokeColor as string[])[0]} />
                        <stop offset="100%" stopColor={(strokeColor as string[])[1]} />
                    </linearGradient>
                </defs>
            )}

            <rect
                x={strokeWidth}
                y={strokeWidth}
                width={effectiveSideLength}
                height={effectiveSideLength}
                fill="none"
                strokeWidth={strokeWidth}
                strokeDasharray={fullLength}
                strokeDashoffset={dashOffset}
                rx={borderRadius}
                ry={borderRadius}
                style={{
                    stroke: useGradient ? 'url(#gradient)' : (strokeColor as string)
                }}
            />
        </svg>
    )
}
